import {
	Search,
	SearchAction,
	SearchActionTypes as actionTypes
} from './searchTypes';

export const searchGetSearchesRequest = (): SearchAction => ({
	type: actionTypes.SEARCH_GET_SEARCHES_REQUEST
});

export const searchGetSearchesSuccess = (payload: Search[]): SearchAction => ({
	type: actionTypes.SEARCH_GET_SEARCHES_SUCCESS,
	payload
});

export const searchGetSearchesFailure = (error: Error): SearchAction => ({
	type: actionTypes.SEARCH_GET_SEARCHES_FAILURE,
	error
});

export const searchAddSearchRequest = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_ADD_SEARCH_REQUEST,
	payload
});

export const searchAddSearchSuccess = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_ADD_SEARCH_SUCCESS,
	payload
});

export const searchAddSearchReset = (): SearchAction => ({
	type: actionTypes.SEARCH_ADD_SEARCH_RESET
});

export const searchAddSearchFailure = (error: Error): SearchAction => ({
	type: actionTypes.SEARCH_ADD_SEARCH_FAILURE,
	error
});

export const searchEditSearchRequest = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_EDIT_SEARCH_REQUEST,
	payload
});

export const searchEditSearchSuccess = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_EDIT_SEARCH_SUCCESS,
	payload
});

export const searchEditSearchFailure = (error: Error): SearchAction => ({
	type: actionTypes.SEARCH_EDIT_SEARCH_FAILURE,
	error
});

export const searchRemoveSearchRequest = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_REMOVE_SEARCH_REQUEST,
	payload
});

export const searchRemoveSearchSuccess = (payload: Search): SearchAction => ({
	type: actionTypes.SEARCH_REMOVE_SEARCH_SUCCESS,
	payload
});

export const searchRemoveSearchFailure = (error: Error): SearchAction => ({
	type: actionTypes.SEARCH_REMOVE_SEARCH_FAILURE,
	error
});

export const searchResetSaveStatus = (): SearchAction => ({
	type: actionTypes.SEARCH_RESET_SAVE_STATUS
});
